import type { SectorCta } from "./sectorConfigs";

export type IletisimKanali = "whatsapp" | "instagram" | "telefon";

/* Ortak hizmet / kategori modeli — tüm 12 sektör aynı shape'i kullanır. */
export interface ServiceCategory {
  id: string;
  name: string;
  images: string[];
}

/* Ortak kampanya modeli — tüm sektörlerde aynı shape. */
export interface Campaign {
  id: string;
  name: string;
  oldPrice?: string;
  newPrice: string;
  description?: string;
}

export interface DemoFormData {
  firmaAdi: string;
  yetkiliAdi: string;
  sektor: string;
  sektorDiger: string;
  hizmetBolgesi: string;
  // legacy fields — cleaning_v1 / event_v1 / generic akışları hâlâ bunları kullanır
  hizmetler: string[];
  anaHizmet: string;
  kampanyaMetni: string;
  logo: string | null;
  gorseller: string[];
  // canonical video kaynağı — tüm sektörlerde ortak
  videolar: string[];
  whatsapp: string;
  instagram: string;
  facebook: string;
  website: string;
  anaIletisimKanali: IletisimKanali;
  sorular: string[];
  ozelSorular: string[];
  tecrubeYili: number | null;
  gucluYonler: string[];
  guvenNotu: string;
  // ortak structured model
  serviceCategories: ServiceCategory[];
  campaigns: Campaign[];
  selectedCtas: SectorCta[];
}

export const GUCLU_YON_OPTIONS = [
  "Uzman Personel",
  "Tecrübe",
  "Uygun Fiyat",
  "Premium Hizmet",
  "Kaliteli / Gelişmiş Ekipman",
  "Hijyen & Güven",
  "Merkezi / Kolay Konum",
  "Yüksek Müşteri Memnuniyeti",
  "Hızlı Hizmet",
  "Diğer",
];

export const SORU_PRESETS = [
  "Adı",
  "Telefonu",
  "İlgilendiği hizmet",
  "Bulunduğu bölge",
  "Randevu tarihi",
  "Bütçe",
  "Etkinlik tarihi",
  "Kişi sayısı",
  "Araç marka/modeli",
  "Özel not",
];

export const MAX_HIZMET = 8;
export const MAX_OZEL_SORU = 5;
export const MAX_GORSEL = 6;
export const MAX_VIDEO = 2;
export const MAX_GUCLU_YON = 3;

export const MIN_SERVICE_CATEGORY = 1;
export const MAX_SERVICE_CATEGORY = 5;
export const MIN_CATEGORY_IMAGE = 3;
export const MAX_CATEGORY_IMAGE = 10;
export const MAX_CAMPAIGN = 5;

export const defaultDemoFormData: DemoFormData = {
  firmaAdi: "",
  yetkiliAdi: "",
  sektor: "",
  sektorDiger: "",
  hizmetBolgesi: "",
  hizmetler: [],
  anaHizmet: "",
  kampanyaMetni: "",
  logo: null,
  gorseller: [],
  videolar: [],
  whatsapp: "",
  instagram: "",
  facebook: "",
  website: "",
  anaIletisimKanali: "whatsapp",
  sorular: [],
  ozelSorular: [],
  tecrubeYili: null,
  gucluYonler: [],
  guvenNotu: "",
  serviceCategories: [],
  campaigns: [],
  selectedCtas: [],
};

/* FUTURE SLOT — FAZ 3D-3'te ödeme entegrasyonu YOK.
   İleride PayTR ödeme bağlantısı buraya bağlanabilir.
   Şu an yalnızca tip affordance; hiçbir ağ çağrısı yok. */
export interface PaymentLinkSlot {
  provider?: "paytr";
  url?: string;
  enabled: false;
}